import type { Input } from './inputs/input';

type RemoteNestedCallback = (field: Input) => Promise<Array<unknown>> | Array<unknown>;

export class RemoteNesteds {
	fieldCallbacks = new Map<string, RemoteNestedCallback>();

	registerRemoteNested(fieldName: string, callback: RemoteNestedCallback) {
		this.fieldCallbacks.set(fieldName, callback);
	}

	hasRemoteNested(fieldName: string) {
		return this.fieldCallbacks.has(fieldName);
	}

	async getRemoteNestedSpec(field: Input) {
		// this won't work for unnamed fields
		if (!field.name) {
			return null;
		}
		const callback = this.fieldCallbacks.get(field.name);

		if (callback) {
			return await callback(field);
		}
	}

	unregisterRemoteNested(fieldName: string) {
		return this.fieldCallbacks.delete(fieldName);
	}
}
